import { AxiosPromise } from 'axios';
import { DetectionFilterCriteria } from 'Models/Videos/Detections/DetectionFilterCriteria';
import { getAxiosInstance } from 'Utils/Http/ApiManager';
import { ApiUrl, getApiUrl } from 'Utils/Http/ApiUrls';

export interface PutChangeAllPlacementsRequest extends DetectionFilterCriteria {
	placementId: number;
}

const putChangeAllPlacementsRequest = (
	token: string | null,
	videoId: number,
	request: PutChangeAllPlacementsRequest
): AxiosPromise<void> => {
	const url = getApiUrl(ApiUrl.VideosVideoDetectionsEditorChangeAllPlacements).replace(':videoId', videoId.toString());
	const axiosInstance = getAxiosInstance(token);
	return axiosInstance.put(url, request);
};

export default putChangeAllPlacementsRequest;
